import InboxIcon from "@mui/icons-material/Inbox";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ListStateIcon } from "../ListStateIcon";

interface IListStateIconArchivedProps {
    hideTooltip?: boolean;
    color?: string;
}

export const ListStateIconArchived = (props: IListStateIconArchivedProps) => {
    return (
        <ListStateIcon
            tooltip={props.hideTooltip ? undefined : Translations.Archived}
            icon={InboxIcon}
            color={props.color}
        />
    );
};
